<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP9.w.1.0.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PP9"></a>
<div class="gtxt_body" id="block.8.0.0.box.280.693.1055.124.q.90" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PP9.w.0.0.0"></a><p class="gtxt_body gtxt_heading" id="para.8.0.0.box.280.693.1055.124.q.90">Acknowledgments</p>
</div>
<div class="gtxt_body" id="block.8.1.0.box.270.1078.1163.1240.q.60">
<a id="ORIG-GBS.PP9.w.1.0.0"></a><p class="gtxt_body" id="para.8.1.0.box.277.1078.1154.197.q.60">Many persons have helped in this work. Appreciation is expressed to living ex-governors, to Governor Dolph Briscoe, Jr., and to members of governors' families who have furnished information.</p>
<a id="ORIG-GBS.PP9.w.1.1.0"></a><p class="gtxt_body" id="para.8.1.1.box.278.1296.1155.590.q.60" style="text-indent:1em;"><a id="GBS.PP9.w.1.1.0"></a>Acknowledgment of indebtedness for materials provided is due R. W. Norton Art Gallery (library), Shreveport, Louisiana; Shreve-Memorial Library, Shreveport; Texas State Library, Austin; and the Texas Collection, University of Texas Library, Austin. Very special thanks are due Miss Nell Cunningham, Louisiana State University in Shreveport Library, who secured rare source material through loans; Mrs. Elizabeth Wallace, Stephen F. Austin State University Library, Nacogdoches, for her generous assistance; and Mrs. Mary Newell Pape, Houston Public Library, Houston.</p>
<a id="ORIG-GBS.PP9.w.1.2.0"></a><p class="gtxt_body" id="para.8.1.2.box.270.1897.1161.421.q.50" style="text-indent:1em;"><a id="GBS.PP9.w.1.2.0"></a>Gratitude is expressed to Dr. Joseph Milton Nance, historian, editor, and professor of history, Texas A &amp; M University, for reading the manuscript and for his thoughtful suggestions, but who is in no way responsible for any errors or oversights; Mrs. Penny Claudis, typist par excellence; Mrs. Mary Martin McDowell, who offered constructive suggestions for smoothness of structure; Mrs. Carol J. Carefoot, Texas State Library, Austin, and Mrs. May<a id="ORIG-GBS.PP10.w.1.0.0"></a><span class="gtxt_body" id="para.9.1.0.box.271.391.1154.99.q.70"><a id="GBS.PP10"></a><a id="GBS.PP10.w.0.0.0"></a><a id="GBS.PP10.w.1.0.0"></a>
Schmidt, Austin Public Library, for assistance in securing photographs.</span></p>
</div>
</div><div style="display:none;"><a id="GBS.PP10.w.1.1.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PP10"></a>
<div class="gtxt_body" id="block.9.1.0.box.271.391.1156.480.q.60">
<a id="ORIG-GBS.PP10.w.1.1.0"></a><p class="gtxt_body" id="para.9.1.1.box.271.501.1156.370.q.60" style="text-indent:1em;">Acknowledgments for use of photographs of Jones, Davis, Throckmorton, Stevenson, Jester, and Preston Smith are due the Texas State Library, Austin; those of Moody, Allred, Daniel, Briscoe, and Connally were furnished by the subjects or members of their families; the others were furnished by the Chalberg Photo Collection, Austin-Travis County Collection, Austin Public Library.</p>
</div>
</div><div style="display:none;"><a id="GBS.PA1"></a><a id="GBS.PA1.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA1.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA2"></a><a id="GBS.PA2.w.0.0.0"></a></div><div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PA1"></a>
<div class="gtxt_body" id="block.10.0.0.box.402.927.880.41.q.80">
<a id="ORIG-GBS.PA1.w.0.0.0"></a><p class="gtxt_body" id="para.10.0.0.box.402.927.880.41.q.80" style="font-size:108%;text-indent:1em;text-align:center;font-weight:bold;text-indent:0;">THE GOVERNORS OF TEXAS</p>
</div>
</div>
<div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PA2.w.0.0.0.1"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0005.vue?816e01e2